import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";

class SolicitudRpt extends Component {
    state = {  }

    contenido = () => {
        let { datos, tipo } = this.props;
        const styles = StyleSheet.create(ADMISION[0]);
        
        let estudiantes = () => {
            if (datos.length === 0) return (
                <View style={[styles.row]}>
                    <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen solicitudes de este tipo</Text>
                </View>
            )

            return (
                datos.map(option => (
                    <View key={option.id} style={[styles.row]}>
                        <Text style={[styles.colTablaList3, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{option.ci}</Text>
                        <Text style={[styles.colTablaList5, styles.font9, styles.bordeCol9, styles.borderTop]}>{option.estudiante}</Text>
                        <Text style={[styles.colTablaList4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>{option.fecha}</Text>
                    </View>
                ))
            )
        }
        
        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    SOLICITUDES DE {(tipo.label).toUpperCase()}
                </Text>
                <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF",}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. LISTADO DE ESTUDIANTES</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaList3, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>Cedula</Text>
                            <Text style={[styles.colTablaList5, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Estudiantes</Text>
                            <Text style={[styles.colTablaList4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Fecha</Text>
                        </View>
                        {estudiantes()}
                    </View>
                </View>
                <View style={[styles.footer]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col6]}>
                        <Text style={[styles.linea3]}></Text>
                            <Text style={[styles.encabezado2]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() {
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title={`Solicitudes de ${this.props.tipo.label}`}>
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default SolicitudRpt;


// WEBPACK FOOTER //
// ./src/components/Reportes/SolicitudRpt.jsx